export default "__VITE_ASSET__DfeONecj__"